module.exports = {"headerStory":"HISTOIRE","storyFrom":"du vietnamien : grand-mère"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = 405
// module chunks = 168707334958949